<template>
  <div class="elevation-1">
    <v-toolbar flat>
      <v-btn flat to="/developer/monitor"> Monitor</v-btn>
      <v-btn flat to="/developer/releases"> Releases</v-btn>
      <v-btn flat to="/developer/broadcaster"> Broadcaster</v-btn>
    </v-toolbar>
    <v-flex xs12>
	  	<router-view></router-view>
	  </v-flex>
  </div>
</template>

<script>


import MonitorPage from './developer/Monitor'
import ReleasePage from './developer/Releases'
import ListDataEditor from './content/ListDataEditor';
import BroadcasterPage from './developer/Broadcaster';


export default {
	routes: [
		{
			path: '',
			redirect: 'monitor'
		},
  	{
      path: 'monitor',
      name: "Developer monitor",
      component: MonitorPage,
    },
    {
      path: 'releases',
      redirect: 'releases/release'
    },
    {
      path: 'releases/:type',
      name: "Developer Release list",
      components: {
        default: ReleasePage
      },
      props: {
        default: true
      },
      children: [
        {
          path: "edit/:id/data/:data_id",
          name: "Developer Release edit",
          components: {
            default: ReleasePage,
            bottomEditor: ListDataEditor
          },
          props: {
            default: true,
            bottomEditor: true
          },
        }
      ]
    },
  {
      path: 'broadcaster',
      redirect: 'broadcaster/release'
    },
    {
      path: 'broadcaster/:type',
      name: "Developer Broadcaster Release list",
      components: {
        default: BroadcasterPage
      },
      props: {
        default: true
      },
      children: [
        {
          path: "edit/:id/data/:data_id",
          name: "Developer Broadcaster Release edit",
          components: {
            default: BroadcasterPage,
            bottomEditor: ListDataEditor
          },
          props: {
            default: true,
            bottomEditor: true
          },
        }
      ]
    },

   ]
}

</script>
